import { render, staticRenderFns } from "./EditStudentDataModal.vue?vue&type=template&id=78c7b500&"
import script from "./EditStudentDataModal.vue?vue&type=script&lang=js&"
export * from "./EditStudentDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports